/** Explicit art aliases, never gameplay aliases. Hidden/special props retain their original IDs. */
export const coastalFrameGroups = [
    { image: "canopy", size: 512, frames: ["oak_tree_leaves_1", "oak_tree_leaves_2"] },
    { image: "birch", size: 512, frames: ["birch_tree_leaves_1", "birch_tree_leaves_2"] },
    { image: "pine", size: 512, frames: ["pine_tree"] },
    { image: "branches", size: 256, frames: ["oak_tree_trunk_1", "oak_tree_trunk_2", "birch_tree_trunk", "pine_tree_trunk"] },
    { image: "stump", size: 256, frames: ["oak_tree_residue", "birch_tree_residue", "pine_tree_residue", "loot_tree_residue"] },
    { image: "bush", size: 256, frames: ["bush"] },
    { image: "blueberry", size: 256, frames: ["blueberry_bush"] },
    { image: "rock", size: 256, frames: [
        ...Array.from({ length: 7 }, (_, i) => `rock_${i + 1}`),
        ...Array.from({ length: 5 }, (_, i) => `river_rock_${i + 1}`)
    ] },
    { image: "crate-wood", size: 256, frames: ["regular_crate"] },
    { image: "crate-orange", size: 256, frames: ["flint_crate"] },
    { image: "crate-blue", size: 256, frames: ["aegis_crate"] },
    { image: "crate-grenade", size: 256, frames: ["grenade_crate"] },
    { image: "crate-melee", size: 256, frames: ["melee_crate"] },
    { image: "barrel-steel", size: 256, frames: ["barrel", "loot_barrel"] },
    { image: "barrel-red", size: 256, frames: ["super_barrel"] }
] as const;

/** Shelf packing keeps shared artwork in one atlas; original sprite sizes are applied separately. */
export function packCoastalFrames(groups: ReadonlyArray<{ readonly image: string, readonly size: number }>) {
    let x = 0;
    let y = 0;
    let rowHeight = 0;
    return groups.map(group => {
        if (x + group.size > 2048) { x = 0; y += rowHeight; rowHeight = 0; }
        if (y + group.size > 2048) throw new Error("Coastal atlas budget exceeded");
        const slot = { ...group, x, y };
        x += group.size;
        rowHeight = Math.max(rowHeight, group.size);
        return slot;
    });
}
